import React, { useEffect } from 'react';
import './Home.css';
import HomeUsage from './HomeUsage/HomeUsage';
import HomeRecently from './HomeRecently/HomeRecently';
import TeamTemplate from './TeamTemplate/TeamTemplate';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
const Home = () => {
    const Navigate = useNavigate();
    const isSubscription = useSelector(
        (state) => state.SettingsUserProfileData?.user_profile_data
    );

    useEffect(() => {
        if (
            isSubscription != undefined &&
            isSubscription != null &&
            isSubscription.id != undefined &&
            isSubscription.id != null
        ) {
            if (!isSubscription?.subscription) {
                Navigate('/settings');
            }
        }
    }, [isSubscription?.id]);

    return (
        <div className='home_Main-container'>
            <HomeUsage />
            <div className='home-recently-used'>
                <HomeRecently />
            </div>
            <div className='team-try-template'>
                <TeamTemplate />
            </div>
        </div>
    );
};

export default Home;
